import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { CustomerSsoConfigQueryKeys } from "./keys";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { ISsoConfigResponse } from "../../models/CustomerSsoConfig/CustomerSsoConfig";

export default function useCustomerSsoConfig(customerId: string) {
  const { get } = useApiHelper();

  const ssoConfig = useQuery({
    queryKey: CustomerSsoConfigQueryKeys.all(customerId),
    queryFn: () =>
      get<IDefaultResponse<ISsoConfigResponse | null>>(
        `/customer/${customerId}/sso`
      ).then((res) => res.data),
  });

  return {
    ssoConfig,
  };
}
